export const female_hair = [ //An array of each Female hairstyle's ID, Atlas file, and name. There are ??.
  {
    id: 'hair1', //For hairstyles, append #vb_ to find id of div. 
    atlas: 'atlas16', //Append to atlas to find class.
    name: 'Tunnel Snake' //Show name in textbox.
    /* Alternatively 'Professor'. */
  },
  {
    id: 'hair2',
    atlas: 'atlas16',
    name: '#2' 		/* NAME ME!! */
  },
  {
    id: 'hair3',
    atlas: 'atlas16',
    name: '#3'    /* NAME ME!! */
  },
  {
    id: 'hair4',
    atlas: 'atlas16',
    name: '#4'    /* NAME ME!! */
  },
  {
    id: 'hair5',
    atlas: 'atlas16',
    name: '#5'    /* NAME ME!! */
  },
  {
    id: 'hair6',
    atlas: 'atlas16',
    name: '#6'    /* NAME ME!! */
  },
  {
    id: 'hair7',
    atlas: 'atlas16',
    name: '#7'    /* NAME ME!! */
  },
  {
    id: 'hair8',
    atlas: 'atlas16',
    name: '#8'    /* NAME ME!! */
  },
  {
    id: 'hair9',
    atlas: 'atlas16',
    name: '#9'    /* NAME ME!! */
  },
  {
    id: 'hair10',
    atlas: 'atlas16',
    name: '#10'    /* NAME ME!! */
  },
  {
    id: 'hair11',
    atlas: 'atlas16',
    name: '#11'    /* NAME ME!! */
  },
  {
    id: 'hair12',
    atlas: 'atlas16',
    name: '#12'    /* NAME ME!! */
  },
  {
    id: 'hair13',
    atlas: 'atlas16',
    name: '#13'    /* NAME ME!! */
  },
  {
    id: 'hair14',
    atlas: 'atlas16',
    name: '#14'    /* NAME ME!! */
  },
  {
    id: 'hair15',
    atlas: 'atlas16',
    name: '#15'    /* NAME ME!! */
  },
  {
    id: 'hair16',
    atlas: 'atlas16',
    name: '#16'    /* NAME ME!! */
  },
  {
    id: 'hair17',
    atlas: 'atlas16',
    name: '#17'    /* NAME ME!! */
  },
  {
    id: 'hair18',
    atlas: 'atlas16',
    name: '#18'    /* NAME ME!! */
  },
  {
    id: 'hair19',
    atlas: 'atlas16',
    name: '#19'    /* NAME ME!! */
  },
  {
    id: 'hair20',
    atlas: 'atlas16',
    name: '#20'    /* NAME ME!! */
  },
  {
    id: 'hair21',
    atlas: 'atlas16',
    name: '#21'    /* NAME ME!! */
  },
  {
    id: 'hair22',
    atlas: 'atlas16',
    name: '#22'    /* NAME ME!! */
  },
  {
    id: 'hair23',
    atlas: 'atlas16',
    name: '#23'    /* NAME ME!! */
  },
  {
    id: 'hair24',
    atlas: 'atlas16',
    name: '#24'    /* NAME ME!! */
  },
  {
    id: 'hair25',
    atlas: 'atlas16',
    name: '#25'    /* NAME ME!! */
  },
  {
    id: 'hair26',
    atlas: 'atlas16',
    name: '#26'    /* NAME ME!! */
  },
  {
    id: 'hair27',
    atlas: '',
    name: 'Balding' /* HairBalding */
  }
];

/* Dr. Li hair is called "HairDrLi" in Fallout 3? Doesn't say Fallout 4. */

/* Piper has Default/HairFemale01 called 'Elegant'.*/


/* Moira & Amata has a HairBun called 'Wendy the Welder'*/

/* Bittercup has a HairBun called 'Prim N Proper'*/

/*http://misc.thefullwiki.org/Haircut*/


/* No hair - 'Shaved' */